import { ChangeIncidenteDTO } from "@/application/dto/incidentes/ChangeIncidenteDTO";
import { IIncidenteRepository } from "@/domain/repositories/IIncidenteRepository";

// application/use-cases/patchIncidenteUseCase.ts

export class PatchIncidenteUseCase {

    constructor(
        private repository: IIncidenteRepository
    ) { }

    async execute(id: string, data: ChangeIncidenteDTO) {
        const changeData: ChangeIncidenteDTO = {
            estado: Number(data.estado),
            responsable: Number(data.responsable),
            tipo_responsable: Number(data.tipo_responsable),
            id_visita: Number(data.id_visita),
        };

        return this.repository.change(id, changeData);
    }

}
